import Relay from 'react-relay';

export default class TransferChannelToDevelMutation extends Relay.Mutation {
    static fragments = {
        channel: () => Relay.QL`
            fragment on Channel {
                id
            }
        `,
    };

    getMutation() {
        return Relay.QL`mutation { transferChannelToDevel }`;
    }

    getVariables() {
        return {
            channelId: this.props.channel.id,
            targetOrganisationId: this.props.targetOrganisationId,
        };
    }

    getFatQuery() {
        return Relay.QL`
            fragment on TransferChannelToDevelPayload {
                result {
                    success
                    message
                    newChannelId
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                Relay.QL`
                    fragment on TransferChannelToDevelPayload {
                        result {
                            success
                            message
                            newChannelId
                        }
                    }
                `,
            ],
        }];
    }
}
